import CXMApiClient from "../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
import Vue from "vue";

function initialState() {
  return {
    showModal: false,
    record: {},
  };
}

const state = initialState();

const getters = {};

const actions = {
  openAssignCallLoggingModal(context, data) {
    context.commit("openAssignCallLoggingModal", data);
  },
  closeAssignCallLoggingModal: function(context) {
    context.commit("closeAssignCallLoggingModal");
  },
  assignEmployee: function(context, request) {
    return new Promise((resolve, reject) => {
        let cxmApiClient = new CXMApiClient();
        cxmApiClient
          .ProcessRequest("POST", "/dashboard/assign_logged_by_user", request)
          .then(resp => {
            if (resp.status == 200)
              resolve();
            else reject(resp);
          })
          .catch(err => {
            reject(err.response);
          });
      });
  },
};

const mutations = {
  openAssignCallLoggingModal: function(state, data) {
    state.showModal = true;
    state.record = data;
  },
  closeAssignCallLoggingModal: function(state) {
    state.showModal = false;
    state.record = {};
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/AssignCallLogging.js